<script lang="ts">
import { Component } from 'vue-property-decorator'
import BaseButton from './BaseButton.vue'

@Component({})
export default class FinishButton extends BaseButton {
  protected color = 'is-info'
}
</script>
